import React from 'react';
import { OrdemDeServicoForm } from '../components/ordemServico/OrdemDeServicoForm';

interface CadastroOSModalProps {
  osId?: number | null;
  isOpen: boolean;
  initialDate?: string;
  onClose: () => void;
  onSaved: (savedId: number) => void;
}

export function CadastroOSModal({ osId, isOpen, initialDate, onClose, onSaved }: CadastroOSModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-3 sm:p-6 overflow-hidden print:p-0 print:bg-white print:block">
      <OrdemDeServicoForm
        osId={osId}
        initialDate={initialDate}
        onClose={onClose}
        onSaved={onSaved}
      />
    </div>
  );
}
